import { getUserPosts } from "@/services/UserService"

export const fetchProfilePosts = async ({ commit }, id) => {
  const posts = await getUserPosts(id)

  commit("setProfilePosts", posts)
}
